// extracted by mini-css-extract-plugin
module.exports = {"root":"AvailableBalance_root__2WLvK"};